import AlchemyModal, { ModalHeader } from 'UIKit/AlchemyModal'
import Box from 'UIKit/Box/Box'
import Button from 'UIKit/Button/Button'
import BackgroundImage from 'UIKit/Image/BackgroundImage'
import Image from 'UIKit/Image/Image'
import { ModalProps } from 'UIKit/Modal/Modal'
import Text from 'UIKit/Text/Text'
import { RouteConfig } from 'config/constants/route'
import useModal, { useCloseAllModal } from 'hooks/useModal'
import { useRouter } from 'hooks/useRouter'
import { ColumnCenter } from 'layout/Components/Column'
import { RowCenter } from 'layout/Components/Row'
import { useCallback } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { ModalColorTheme } from 'theme/modal/colors'
import { removeHUSDBonusStorage } from 'utils/signupBonus'

export interface SignUpSuccessWithBonusModalProps {
  isSignUpWithBonus: boolean
  husdBonusAmount?: number
}

const SIGNUP_BONUS_BENEFIT_IMAGES = [
  '/images/bonusCenter/signup-bonus-benefit-1.png',
  '/images/bonusCenter/signup-bonus-benefit-2.png',
  '/images/bonusCenter/signup-bonus-benefit-3.png',
]

const SignUpSuccessWithBonusModal: React.FC<ModalProps<SignUpSuccessWithBonusModalProps>> = ({
  onDismiss,
  data: { isSignUpWithBonus, husdBonusAmount },
}) => {
  const router = useRouter()
  const handleRemoveStorageBonus = useCallback(() => {
    removeHUSDBonusStorage()
  }, [])
  const closeModal = useCloseAllModal()

  return (
    <AlchemyModal
      colorTheme={ModalColorTheme.Darkblue}
      onDismiss={() => {
        onDismiss()
        handleRemoveStorageBonus()
      }}
      minWidth={['', '', '520px !important', '680px !important']}
      minHeight={[]}
      padding="0px !important"
    >
      <BackgroundImage
        src="/images/bonusCenter/background-sign-up-with-bonus-v2.png"
        width="100%"
        paddingBottom={[360, 380, 400, 450]}
      >
        <ModalHeader colorTheme={ModalColorTheme.Darkblue} padding="20px !important" />
        <Box
          position="absolute"
          top={10}
          right={0}
          bottom={0}
          left={0}
          minWidth="auto"
          minHeight={450}
          m={['40px 10px 0', , '40px 0 0']}
        >
          <ColumnCenter marginBottom={50}>
            <Box width={[280, 320, 400, 440]} height={[100, , 120]} position="relative" top={-40} mt={['28px', , '0']}>
              <Image src="/images/bonusCenter/title-tutorial-v2.png" width={440} height={120} />
            </Box>
          </ColumnCenter>

          <ColumnCenter position="relative" top={['-75px', '-65px', , '-40px']}>
            <Text fontSize={['14px', , '16px']} fontWeight={700} color="text" textAlign="center">
              {isSignUpWithBonus && husdBonusAmount ? (
                <Trans>Congratulation on receiving Welcome Pack</Trans>
              ) : (
                <Trans>Ready for a world of rewards?</Trans>
              )}
            </Text>

            <StyledRowCenter my={['16px', '20px', '32px']} width="100%">
              {SIGNUP_BONUS_BENEFIT_IMAGES.map((src, idx) => (
                <Box key={src} width={['100px', , '120px', '140px']}>
                  <Image
                    src={src}
                    width={140}
                    height={140}
                    alt={`signup-bonus-benefit-${idx + 1}`}
                    style={{ width: '100%' }}
                  />
                </Box>
              ))}
            </StyledRowCenter>

            <Button
              width={['100%', '320px']}
              height="48px"
              mb={40}
              onClick={() => {
                router.push(RouteConfig.BonusCenter)
                handleRemoveStorageBonus()
                closeModal()
              }}
            >
              <Text fontWeight={700} fontSize="14px" letterSpacing={0.5}>
                <Trans>Claim Your Bonuses</Trans>
              </Text>
            </Button>
          </ColumnCenter>
        </Box>
      </BackgroundImage>
    </AlchemyModal>
  )
}

const StyledRowCenter = styled(RowCenter)`
  gap: 16px;

  ${({ theme }) => theme.mediaQueries.xs} {
    gap: 20px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    gap: 32px;
  }
`

export const SIGN_UP_SUCCESS_MODAL = 'signup-success'

const useSignUpSuccessWithBonusModal = () => {
  const modal = useModal(SignUpSuccessWithBonusModal, SIGN_UP_SUCCESS_MODAL)

  return modal
}

export default useSignUpSuccessWithBonusModal
